<template>
  <div id="app">
    <div class="carousel-wrapper">
      <carousel-sides>
        <template v-slot:content>
          <background
            v-for="(content, index) in contents"
            :key="`bg${index}`"
            :content="content"
            :index="index"
            :currentSlide="currentSlide"
          ></background>
          <slide
            v-for="(content, index) in contents"
            :key="index"
            :content="content"
            :index="index"
            :currentSlide="currentSlide"
          ></slide>
          <bullets
            :contents="contents"
            :currentSlide="currentSlide"
            @nav-to="nextSlide => nav(nextSlide)"
          ></bullets>
        </template>
      </carousel-sides>
      <nav-links
        :currentSlide="currentSlide"
        @nav-to="nextSlide => nav(nextSlide)"
      ></nav-links>
    </div>
  </div>
</template>

<script>
import Background from '@/components/carousel/Background'
import Bullets from '@/components/carousel/Bullets'
import CarouselSides from '@/components/carousel/CarouselSides'
import NavLinks from '@/components/carousel/NavLinks'
import Slide from '@/components/carousel/Slide'

export default {
  data() {
    return {
      contents: [],
      currentSlide: 0,
      direction: 'forward',
      interval: null
    }
  },
  computed: {
    maxIndex() {
      return this.contents.length - 1
    }
  },
  mounted() {
    this.setContents()
    this.setAutoNav()
  },
  methods: {
    setContents() {
      const contents = document.querySelectorAll('.carousel-slide')

      contents.forEach(content => {
        this.contents.push({
          title: content.querySelector('.carousel-slide-title div').innerHTML,
          image: content.querySelector('.carousel-slide-image').innerHTML,
          link: {
            text: content.querySelector('.carousel-slide-link a').textContent,
            url: content.querySelector('.carousel-slide-link a').href
          }
        })
      })
    },
    setAutoNav() {
      clearInterval(this.interval)

      this.interval = setInterval(() => {
        this.nav(this.currentSlide + 1)
      }, 6000)
    },
    nav(nextSlide) {
      if (nextSlide < 0) {
        nextSlide = this.maxIndex
      } else if (nextSlide > this.maxIndex) {
        nextSlide = 0
      }

      this.currentSlide = nextSlide
      this.setAutoNav()
    }
  },
  components: {
    Background,
    Bullets,
    CarouselSides,
    NavLinks,
    Slide
  }
}
</script>

<style lang="scss">
.carousel-wrapper {
  position: relative;
}
</style>
